<template>
  <div class="section-base" id="scroll-target">
    <template v-if="!isSuccessBlock && loaded">
      <div class="alert-base" v-if="autoRegionSelect">
        <v-alert prominent text color="primary">
        <span>
          Уважаемые пользователи! <br>
          Обращаем ваше внимание, что в соответствии с требованиями законодательства заявление будет направленно нотариусам субъекта Российской Федерации, соответствующего месту жительства (регистрации) должника - физического лица или месту нахождения должника - юридического лица.
        </span>
        </v-alert>
      </div>
      <div v-if="dataStatement.statementType" class="section-base__title-box">
        <div class="section-base__title">
          {{ mapStatementName[dataStatement.statementType] }}
        </div>
      </div>


      <div class="form-section-base__title">
        {{
          autoRegionSelect
          ? 'Сведения о месте совершения нотариального действия'
          : 'Выбор места совершения нотариального действия'
        }}
      </div>

      <MapElement
        @region-code-change="regionCode = $event"
        @district-id-change="districtId = $event"
        :statement-type="dataStatement.statementType"
        :region-code="regionCode"
        :district-id="districtId"
        :error-messages="getValidationErrorText($v.regionCode)"
      />

      <div class="form-base__footer">
        <v-container>
          <v-row>
            <v-col>
              <div class="button-box justify-space-between">
                <div>
                  <v-btn
                    depressed
                    color=""
                    class="button-base-white"
                    @click="goDetails"
                    >Просмотреть заявление
                  </v-btn>
                  <v-btn
                    v-if="dataStatement.xmlFileLink"
                    depressed
                    color=""
                    :href="getFileLink(dataStatement.xmlFileLink)"
                    class="button-base-white ml-5"
                    >Скачать заявление
                  </v-btn>
                </div>
                <div>
                  <v-btn
                    @click="goBack"
                    depressed
                    color="primary"
                    class="button-base"
                    >Назад
                  </v-btn>
                  <v-btn
                    depressed
                    :loading="loading"
                    color="primary"
                    class="button-base ml-5"
                    @click="sendRequest"
                    >Отправить
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </template>

    <SkeletonLoader v-if="loading" />
    <AltDistrictSuccess v-if="isSuccessBlock" />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

import { RouteText, RoutePath } from '@/router';
import { BreadCrumbsModule } from '@/store/modules/breadCrumbs';
import { AltDistrictModule } from '@/store/modules/alternativeServices/altDistrict';
import { mapStatementName } from '@/utils/services';
import { RouteName } from '@/router';
import { getFileLink } from '@/api/filestorage';
import MapElement from '@/components/services/elements/MapElement';
import AltDistrictSuccess from '@/views/alternativeServices/AltDistrictSuccess';
import { MapModule } from '@/store/modules/map';
import { getValidationErrorText } from '@/utils/validate';
import SkeletonLoader from '@/components/base/SkeletonLoader';
import {StatementType} from "../../types/services";
import {noticeRecoveryRegion} from "@/app.config";

export default {
  name: 'AltRegion',
  props: {
    parentStatementId: {
      type: String,
      required: true,
    },
  },
  components: {
    SkeletonLoader,
    MapElement,
    AltDistrictSuccess,
  },
  data() {
    return {
      RouteText,
      mapStatementName,
      getFileLink,
      isSuccessBlock: false,
      getValidationErrorText,
      regionCode: '',
      districtId: null,
      StatementType
    };
  },
  validations: {
    regionCode: {
      required,
    },
  },
  computed: {
    dataStatement() {
      return AltDistrictModule.dataStatement;
    },
    loaded() {
      return AltDistrictModule.loaded;
    },
    loading() {
      return AltDistrictModule.loading;
    },
    districts() {
      return MapModule.districts.entity;
    },
    selectedDistrict() {
      return this.districts.find(
        (district) => district.districtId === this.districtId
      );
    },
    autoRegionSelect() {
      return this.dataStatement.statementType === StatementType.NOTICE_RECOVERY && noticeRecoveryRegion
    },
  },
  async created() {
    await AltDistrictModule.getStatementById(this.parentStatementId);
    if (this.autoRegionSelect)
      this.regionCode = this.dataStatement?.locationStep?.regionCode;

    BreadCrumbsModule.SET({
      back: true,
      path: [
        {
          text: RouteText.HOME,
          disabled: false,
          href: RoutePath.HOME,
        },
        {
          text: RouteText.STATEMENTS,
          disabled: false,
          href: RoutePath.STATEMENTS,
        },
        {
          text: RouteText.STATEMENT_DETAIL,
          disabled: false,
          href: `${RoutePath.STATEMENTS}/${this.parentStatementId}`,
        },
        {
          text: RouteText.ALTERNATIVE_SERVICE_DISTRICT,
          disabled: true,
        },
      ],
    });
  },
  beforeDestroy() {
    BreadCrumbsModule.SET(null);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goDetails() {
      this.$router.push({
        name: RouteName.FORM_VIEW,
        params: { statementId: this.parentStatementId },
      });
    },
    async scrollToTop() {
      await this.$vuetify.goTo('#scroll-target', { duration: 100 });
    },

    async sendRequest() {
      this.$v.$touch();
      await this.scrollToTop();

      if (this.$v.$invalid) return;

      const data = {
        regionCode: this.regionCode,
        statementId: this.parentStatementId,
        districtId: this.districtId,
        chamberId: this.selectedDistrict?.chamberId || null,
      };
      const success = await AltDistrictModule.updateDistrict(data);

      if (success) this.isSuccessBlock = true;
    },
  },
};
</script>
